export default {
  AmpYellow: {
    alertText: "This is an Alert",
    buttonLabel: "Learn more",
    buttonLink: "#",
    backgroundColor: "limoncello"
  }
}
